import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
const parentPage = /^\/parent(?:\/|\.html)?$/.test(window.location.pathname);
const App = parentPage
  ? lazy(() => import("./parent/ParentApp.jsx"))
  : lazy(() => import("./island/App.jsx"));
if (parentPage) document.title = "家长手记 · 故事小岛";
createRoot(document.getElementById("root")).render(
  <Suspense
    fallback={
      <div style={{ padding: 40, color: "#486b60", fontFamily: "sans-serif" }}>
        {parentPage ? "正在翻开手记…" : "小岛正在醒来…"}
      </div>
    }
  >
    <App />
  </Suspense>,
);
